import LazyLoadOnScroll from "@Components/LazyLoadOnScroll";
import styles from "./tag.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import useIsDesktop from "hooks/useIsDesktop";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import useTranslationHook from "hooks/useTranslationHook";
import useIsApp from "hooks/useIsApp";
import config from "@Config/index";

type TagProps = {
  Icon: any;
  text: string;
  dataTestId?: string;
  variant?: "offer" | "instant" | "default" | "highlighted";
};

const Tag = ({ Icon, text, dataTestId, variant = "default" }: TagProps) => {
  const isDesktop = useIsDesktop();
  const { t } = useTranslationHook();
  const isApp = useIsApp();
  const isChinaAndApp = isApp || config.IS_CHINA_APP;
  const resolvedVariant = variant === "highlighted" && isChinaAndApp ? "Chinahighlighted" : variant;
  return (
    <div
      className={formatClassNames(
        styles.tagContainer,
        isDesktop && styles.desktop,
        styles[resolvedVariant],
      )}
      data-testid={dataTestId}
    >
      <LazyLoadOnScroll
        customRootMargin="0px"
        fallback={
          <section
            style={{
              height: "16px",
              width: "16px",
            }}
          />
        }
      >
        <Icon />
      </LazyLoadOnScroll>
      <div className={styles.tagText}>{t(text, undefined, { dynamic: true })}</div>
    </div>
  );
};

export default wrapperHOC(Tag, {
  componentName: "Tag-InventoryDetailTags-SearchListItemDesktop-SearchPage",
  showForChina: true,
});
